const seekVideo = (video, time) => new Promise((resolve, reject) => {
  const timeout = window.setTimeout(() => reject(new Error('Video frame extraction timed out.')), 10000);
  const done = () => {
    window.clearTimeout(timeout);
    video.removeEventListener('seeked', done);
    resolve();
  };
  video.addEventListener('seeked', done);
  video.currentTime = Math.min(time, Math.max(0, video.duration - 0.05));
});

export async function extractFrames(video, interval, maxFrames) {
  if (!Number.isFinite(video.duration) || video.duration <= 0) {
    throw new Error('The video duration could not be read.');
  }

  const count = Math.min(maxFrames, Math.max(1, Math.ceil(video.duration / interval)));
  const spacing = video.duration / count;
  const canvas = document.createElement('canvas');
  const scale = Math.min(1, 960 / video.videoWidth);
  canvas.width = Math.max(1, Math.round(video.videoWidth * scale));
  canvas.height = Math.max(1, Math.round(video.videoHeight * scale));
  const context = canvas.getContext('2d');
  const frames = [];

  for (let index = 0; index < count; index += 1) {
    const timestamp = Number(Math.min(index * spacing, video.duration).toFixed(3));
    await seekVideo(video, timestamp);
    context.drawImage(video, 0, 0, canvas.width, canvas.height);
    frames.push({ timestamp, imageUrl: canvas.toDataURL('image/jpeg', 0.72) });
  }

  return frames;
}